export const isNotBanned = (viewer, onFail) => {
    if (viewer.is_banned) {
        onFail('Account banned from using this service.');
    }
    return !viewer.is_banned;
};
export const isApproved = (viewer, onFail) => {
    if (!viewer.is_approved) {
        onFail('Account not approved to use this service yet.');
    }
    return viewer.is_approved;
};
export const emailConfirmed = (viewer, onFail) => {
    if (!viewer.email_is_confirmed) {
        onFail('Email not confirmed yet.');
    }
    return viewer.email_is_confirmed;
};
//# sourceMappingURL=helpers.js.map